export default __webpack_public_path__ + "static/media/default-woman-avatar.88958589.jpg";